import {useContext, useState} from 'react'

import PropTypes from 'prop-types'

import AtomImage from '@s-ui/react-atom-image'
import AtomSpinner from '@s-ui/react-atom-spinner'
import Context from '@s-ui/react-context'
import ActionAdFavorite, {actionAdFavoriteTrackingOrigins, actionAdFavoriteTypes} from '@adv-mt/mt-actions-ad-favorite'

const DEFAULT_PHOTO = 'images/vehicle-no-photo.png'

const BASE_CLASS = 'mt-CardRelatedAdMedia'

const atomImageClass = `sui-AtomImage-image ${BASE_CLASS}-thumbnailImage`

const CardRelatedAdMedia = ({src, alt, ad = {}, extendedTrackingData = {}, hasFavouriteAction = false}) => {
  const {domain} = useContext(Context)
  const [isLoaded, setIsLoaded] = useState(false)
  const urlStatics = domain.get('config').get('urlStatics')
  const defaultPhotoSrc = `${urlStatics}${DEFAULT_PHOTO}`

  const _handleOnLoad = () => {
    setIsLoaded(true)
  }

  return (
    <div className={BASE_CLASS}>
      <div className={`${BASE_CLASS}-thumbnail`}>
        <AtomImage
          alt={alt}
          className={atomImageClass}
          onLoad={_handleOnLoad}
          placeholder={!isLoaded && defaultPhotoSrc}
          spinner={<AtomSpinner />}
          src={src || defaultPhotoSrc}
        />
      </div>
      {hasFavouriteAction && (
        <ActionAdFavorite
          ad={ad}
          isFavorite={ad.isFavorite}
          extendedTrackingData={extendedTrackingData}
          trackingOrigin={actionAdFavoriteTrackingOrigins.RELATED_AD_FAVORITED}
          type={actionAdFavoriteTypes.OVERLAY_ICON_BUTTON}
          className={`${BASE_CLASS}-favorite`}
        />
      )}
    </div>
  )
}

CardRelatedAdMedia.displayName = 'CardRelatedAdMedia'

CardRelatedAdMedia.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  ad: PropTypes.object,
  extendedTrackingData: PropTypes.object,
  hasFavouriteAction: PropTypes.bool
}

export default CardRelatedAdMedia
